import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const Markdown = ({ children, testId }) => (
  <div data-testid={testId} className="text-sm leading-relaxed text-stone-800 space-y-2 [&_h1]:font-heading [&_h1]:text-lg [&_h1]:font-bold [&_h2]:font-heading [&_h2]:text-base [&_h2]:font-bold [&_h3]:font-bold [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_table]:w-full [&_table]:text-xs [&_th]:text-left [&_th]:border-b [&_th]:border-stone-200 [&_th]:py-1 [&_td]:py-1 [&_td]:border-b [&_td]:border-stone-100 [&_strong]:text-stone-900 [&_code]:bg-stone-100 [&_code]:px-1 [&_code]:rounded">
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{children || ""}</ReactMarkdown>
  </div>
);
